import { useUpdateVisibility } from '@/features/student/hooks/useProfile'

export type VisibilityFieldKey =
  'current_ctc' | 'expected_ctc' | 'contact_number' | 'current_company' | 'dob'

interface FieldVisibilityToggleProps {
  fieldKey: VisibilityFieldKey
  label: string
  visible: boolean
}

/** Per-field recruiter-visibility opt-out (Phase 4 backend feature). */
export function FieldVisibilityToggle({ fieldKey, label, visible }: FieldVisibilityToggleProps) {
  const updateVisibility = useUpdateVisibility()

  return (
    <div className="form-check form-switch d-inline-flex align-items-center gap-2">
      <input
        type="checkbox"
        className="form-check-input"
        role="switch"
        id={`visibility-${fieldKey}`}
        checked={visible}
        disabled={updateVisibility.isPending}
        onChange={(e) => updateVisibility.mutate({ [fieldKey]: e.target.checked })}
      />
      <label htmlFor={`visibility-${fieldKey}`} className="form-check-label fs-12 text-muted">
        Visible to recruiters: {label}
      </label>
    </div>
  )
}
